import { camelCaseKeys } from 'config/utils';
import root from 'window-or-global';
import * as ActionTypes from '../actions';

export default function admin(state = getInitialState(root.ADMIN_STATE), action) {
  switch (action.type) {
    case ActionTypes.HANDLE_ADMIN_TOGGLE_LINK_REQUEST: {
      return {
        ...state,
        isRequesting: true,
      };
    }

    case ActionTypes.HANDLE_ADMIN_TOGGLE_LINK_SUCCESS: {
      return {
        ...state,
        isRequesting: false,
        isLive: !state.isLive,
      };
    }

    case ActionTypes.HANDLE_ADMIN_TOGGLE_LINK_FAILURE: {
      return {
        ...state,
        isRequesting: false,
      };
    }

    default:
      return state;
  }
}

function getInitialState (state) {
  if (state) {
    return camelCaseKeys(state);
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/admin/reducers/index.js